var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarbonMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.953613,
    width: 59.0927,
    height: 59.0927,
    rx: 17.3802,
    fill: "#C17B31"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.84992,
    clipPath: "url(#clip0_239_35)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M38.9457 11.2971H22.133C16.0062 11.2971 12.5349 14.7684 12.5349 20.8952V37.6919C12.5349 43.8187 16.0062 47.29 22.133 47.29H38.9457C45.0725 47.29 48.5278 43.8187 48.5278 37.6919V20.8952C48.5278 14.7684 45.0725 11.2971 38.9457 11.2971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_239_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.9536 37H38.9536V33H36.9536V37H32.9536V39H36.9536V43H38.9536V39H42.9536V37Z",
    fill: "#C17B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9536 41V23H36.9536V30H38.9536V19C38.9531 18.4697 38.7422 17.9613 38.3672 17.5864C37.9923 17.2114 37.4839 17.0005 36.9536 17H24.9536C24.4233 17.0005 23.9149 17.2114 23.54 17.5864C23.165 17.9613 22.9541 18.4697 22.9536 19V41C22.9541 41.5303 23.165 42.0387 23.54 42.4136C23.9149 42.7886 24.4233 42.9995 24.9536 43H30.9536V41H24.9536ZM24.9536 19H36.9536V21H24.9536V19Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_239_35"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.4985,
    height: 36.4985,
    fill: "white",
    transform: "translate(12.2506 11.2971)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_239_35"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(14.9536 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonMobile);
export default __webpack_public_path__ + "static/media/carbon_mobile.9f24cef43b0e99837272c667984929c3.svg";
export { ForwardRef as ReactComponent };